import { jsx as _jsx } from "react/jsx-runtime";
import { TranslateProvider } from "@helium10/re-core";
import LocalizedStrings from "localized-strings";
import { createContext, useContext } from "react";
import de from "./translates/de.json";
import en from "./translates/en.json";
import es from "./translates/es.json";
import it from "./translates/it.json";
import zh from "./translates/zh_CN.json";
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const strings = new LocalizedStrings({ en, de, es, it, zh }, { logsEnabled: false });
export const MiscellaneousTranslateProvider = ({ children, forceLang, }) => {
    return (_jsx(TranslateProvider, { strings: strings, TranslateContext: TranslateContext, forceLang: forceLang, children: children }));
};
const TranslateContext = createContext(null);
export const useTranslation = () => {
    const context = useContext(TranslateContext);
    if (!context) {
        throw new Error("[Translation] The provider is not defined");
    }
    return context;
};
